module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "PROLOGUE.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-9"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("PROLOGUE")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("R")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ICK")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(" A")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("LLYN")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("TUGGED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("at the sky-blue tie that had been looped around his neck by one of the production assistants of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("True Love,")]), _vm._v(" a dating reality show. Only moments away from proposing to the one woman he’d never believed he’d find, he should feel anxious, right? The butterflies running bases in his stomach only proved his human nature.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After all, Brandy could say no.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But she wouldn’t. Not to him. At twenty-five, he was the entire package—looks, smarts and, after his agent worked out the details of his contract, a major-league baseball player.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lizzie Maier walked toward him. Serious, as always. She was wearing a purple power suit; her long brown hair was tied up in some ridiculous style that only emphasized the sharpness of her cheekbones. And the grass-green of her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He held up his hands in surrender. “What did I do now?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lizzie shook her head and reached up to straighten his tie. “She’s almost ready for you.” She didn’t look him in the eyes, but kept her focus on his suit and the fit of it. “Are you sure about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Finally she looked up at him. “Brandy’s an amazing woman. Beautiful. Smart. What man wouldn’t want to be married to her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Right.” Lizzie nodded, then tapped her earpiece and shook her head. “They’re still not ready. Rick, I should tell you—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lizzie, relax.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s Elizabeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not to me.” He winked at her. “I’m going to propose. She’ll say yes. Then you’re going to throw us the biggest, most romantic wedding that has ever aired on television.” Rick rolled his head around his neck to get out the tension. “Now, let’s get this show on the road. The rock in my pocket is weighing me down.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What if she doesn’t pick you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick laughed and shook his head. “She’s going to pick Wade? Give me a break. It’s not like all of us didn’t warn her about him. Brandy’s a smart girl. She knows.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rick—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s fine. Really, Lizzie.” He straightened his shoulders and touched his tie. “I’m getting the girl. I’m winning her heart. And you can print that in the tabloids.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lizzie tapped her earpiece again. “Okay, they’re ready for you.” She studied him, then sighed. “You’ve been a good friend to me during this show. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He winked. “Let’s go propose on live television.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-7"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-632e288e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PROLOGUE.vue
// module id = 78
// module chunks = 0